export const subAccounts = {
  title: 'Sub-Accounts',
  subtitle: 'Team-Mitglieder und Reseller-Kunden verwalten',
  navTitle: 'Sub-Accounts',
  invite: 'Einladen',
  mySubAccounts: 'Meine Sub-Accounts',
  myParents: 'Meine Eltern-Accounts',
  filterAll: 'Alle',
  search: 'Suchen...',
  loading: 'Lade Sub-Accounts...',
  empty: 'Keine Sub-Accounts',
  emptyChildren: 'Du hast noch keine Sub-Accounts. Lade Team-Mitglieder oder Reseller-Kunden ein.',
  emptyParents: 'Du bist keinem Eltern-Account zugeordnet.',
  billingShared: 'Gemeinsame Abrechnung',
  billingIndependent: 'Eigene Abrechnung',
  inviteExpires: 'Gültig bis {date}',
  types: {
    team: 'Team',
    reseller: 'Reseller'
  },
  switchedNotice: 'Sub-Accounts verwaltest du in deinem eigenen Account. Kehre dorthin zurück, um sie zu sehen.',
  status: {
    active: 'Aktiv',
    pending: 'Ausstehend',
    deactivated: 'Deaktiviert',
    expired: 'Abgelaufen',
    revoked: 'Zurückgezogen',
    awaitingAcceptance: 'Wartet auf Bestätigung'
  },
  roles: {
    viewer: 'Betrachter',
    editor: 'Bearbeiter',
    manager: 'Manager'
  },
  roleDescriptions: {
    viewer: 'Liest Domains, Mail und Hosting, ohne etwas zu ändern. Passwörter, SFTP-Zugang und die Kubeconfig bleiben verborgen.',
    editor: 'Liest und ändert Domains, Mail und Hosting, Passwörter, SFTP-Zugang und Kubeconfig eingeschlossen. Löschen ist nicht möglich.',
    manager: 'Alles, was ein Bearbeiter darf, dazu Löschen, auch von Servern. Abrechnung, Zahlungen und Kontoeinstellungen bleiben dem Eigentümer vorbehalten.'
  },
  actions: {
    resend: 'Einladung erneut senden',
    edit: 'Bearbeiten',
    revoke: 'Einladung zurückziehen',
    deactivate: 'Deaktivieren',
    reactivate: 'Reaktivieren',
    delete: 'Entfernen'
  },
  removeModal: {
    revokeTitle: 'Einladung zurückziehen?',
    revokeMessage: 'Die Einladung an {account} wird ungültig.',
    deleteTitle: 'Verknüpfung entfernen?',
    deleteMessage: 'Die Verknüpfung mit {account} wird endgültig entfernt. Für eine neue brauchst du eine neue Einladung.'
  },
  parentActions: {
    reacceptNote: 'Dein Reseller bittet darum, den Zugriff wiederherzustellen. Nimm die Einladung über den Link in der Einladungsmail an.',
    leave: 'Verknüpfung verlassen',
    leaveTitle: 'Verknüpfung verlassen?',
    leaveMessage: {
      team: 'Du verlierst den Zugriff auf den Account von {account}. {account} bekommt eine Nachricht.',
      reseller: 'Du bist dann kein Kunde von {account} mehr. {account} bekommt eine Nachricht.'
    },
    billingTitle: 'Abrechnungsmodus ändern?',
    billingMessage: {
      shared: 'Der Reseller kann dann in deinem Namen bestellen, die Zahlungsarten in deinem Account nutzen und verwalten und deine Rechnungen sehen. Die Rechnungen gehen weiter an dich.',
      independent: 'Du bezahlst die Leistungen in deinem Account dann selbst, und der Reseller kann für dich nichts mehr bestellen oder bezahlen.'
    },
    billingTo: {
      shared: 'Auf gemeinsame Abrechnung umstellen',
      independent: 'Auf eigene Abrechnung umstellen'
    }
  },
  inviteSlider: {
    title: 'Sub-Account einladen',
    subtitle: 'Lade ein Team-Mitglied oder einen Reseller-Kunden ein',
    email: 'E-Mail-Adresse',
    emailPlaceholder: "email{'@'}beispiel.de",
    type: 'Beziehungstyp',
    billingMode: 'Abrechnungsmodus',
    teamRole: 'Team-Rolle',
    label: 'Bezeichnung',
    labelPlaceholder: 'z.B. Entwickler-Team, Agentur XY...',
    resellerUnavailable: 'Reseller-Kunden sind für deinen Account nicht freigeschaltet. Wende dich an den Support, um sie freizuschalten.',
    send: 'Einladung senden'
  },
  editSlider: {
    title: 'Sub-Account bearbeiten',
    type: 'Typ',
    status: 'Status',
    billingMode: 'Abrechnungsmodus',
    teamRole: 'Team-Rolle',
    label: 'Bezeichnung',
    billingRelaxHint: {
      reseller: 'Zurück auf gemeinsame Abrechnung stellen kann nur der Kunde selbst.',
      team: 'Zurück auf gemeinsame Abrechnung stellen kann nur der Support.'
    }
  },
  deactivateModal: {
    title: 'Sub-Account deaktivieren?',
    message: 'Möchtest du die Beziehung zu {account} wirklich deaktivieren?',
    warning: 'Der Sub-Account verliert den Zugriff auf deine Ressourcen.',
    confirm: 'Deaktivieren',
    reason: 'Grund'
  },
  contextBanner: {
    actingTeam: 'Du arbeitest als Team-Mitglied im Account {account}, beschränkt auf deine Team-Rolle.',
    actingReseller: 'Du arbeitest als Reseller im Account {account}.',
    returnBtn: 'Zurück zum eigenen Account',
    returnFailed: 'Rückkehr fehlgeschlagen'
  },
  inviteAccept: {
    title: 'Einladung annehmen',
    subtitle: '{name} hat dich als Sub-Account eingeladen',
    from: 'Von',
    type: 'Typ',
    billing: 'Abrechnung',
    accept: 'Einladung annehmen',
    decline: 'Ablehnen',
    loading: 'Einladung wird geladen...',
    errorTitle: 'Fehler',
    invalidToken: 'Diese Einladung ist ungültig oder abgelaufen.',
    loadError: 'Die Einladung konnte nicht geladen werden.',
    acceptError: 'Die Einladung konnte nicht angenommen werden.',
    successTitle: 'Einladung angenommen',
    successMessage: 'Du bist jetzt als Sub-Account verknüpft.',
    goHome: 'Zur Startseite',
    goDashboard: 'Zum Dashboard',
    for: 'Für',
    expires: 'Gültig bis',
    billingSharedNote: 'Bei gemeinsamer Abrechnung kann der Reseller in deinem Namen bestellen, die Zahlungsarten in deinem Account nutzen und verwalten und deine Rechnungen sehen. Die Rechnungen gehen an dich.',
    billingIndependentNote: 'Bei eigener Abrechnung bezahlst du die Leistungen in deinem Account selbst. Der Reseller kann für dich nichts bestellen oder bezahlen.',
    loginPrompt: 'Melde dich mit dem eingeladenen Account an, um die Einladung anzunehmen.',
    loginToAccept: 'Anmelden und annehmen',
    register: 'Noch kein Account? Registrieren',
    otherAccount: 'Diese Einladung gilt für {email}. Melde dich mit diesem Account an, um sie anzunehmen oder abzulehnen.',
    loginRequired: 'Deine Sitzung ist abgelaufen. Melde dich erneut an.',
    unknown: 'Diese Einladung gibt es nicht oder nicht mehr. Vielleicht wurde sie zurückgezogen oder abgelehnt.',
    used: 'Diese Einladung wurde bereits verwendet.',
    expired: 'Diese Einladung ist abgelaufen. Bitte die Person, die dich eingeladen hat, um eine neue.',
    deactivated: 'Diese Einladung hat der Absender deaktiviert.',
    inviterLimit: 'Der einladende Account hat keinen Platz mehr für dich. Bitte die Person, die dich eingeladen hat, sich darum zu kümmern.',
    resellerParentExists: 'Dein Account gehört schon zu einem anderen Reseller. Verlasse diese Verknüpfung zuerst, wenn du wechseln willst.',
    declinedTitle: 'Einladung abgelehnt',
    declinedMessage: 'Die Einladung ist abgelehnt. Wer dich eingeladen hat, bekommt eine Nachricht.'
  },
  resources: {
    tab: 'Ressourcen',
    title: 'Sub-Account Ressourcen',
    subtitle: 'Übersicht aller Domains und Mail-Accounts deiner Sub-Accounts',
    loading: 'Lade Ressourcen...',
    empty: 'Keine Ressourcen',
    emptyMessage: 'Deine Sub-Accounts haben noch keine Domains oder Mail-Accounts.',
    domains: 'Domains',
    mailAccounts: 'Mail-Accounts',
    domainStatus: {
      active: 'Aktiv',
      pending_delete: 'Gekündigt',
      deleted: 'Gelöscht',
      suspended: 'Gesperrt',
      trade_out: 'Transfer',
      transfer_pending: 'Transfer läuft',
      external: 'Extern'
    },
    activeUntil: 'Aktiv bis',
    switchTo: 'Verwalten',
    totalDomains: 'Domains gesamt',
    totalMail: 'Mail-Accounts gesamt'
  },
  errors: {
    labelTooLong: 'Die Bezeichnung ist zu lang. Kürze sie, Umlaute zählen doppelt.',
    switch_target_forbidden: 'In diesen Account kannst du nicht wechseln.',
    invite_resend_cooldown: 'Diese Einladung wurde gerade erst verschickt. Du kannst sie in ein paar Minuten erneut senden.',
    conflicting_relationship: 'Zwischen diesen Accounts gibt es schon eine andere Verknüpfung.',
    parent_not_reseller: 'Dieser Account darf keine Reseller-Kunden haben.',
    action_blocked_during_impersonation: 'Das ist während einer Impersonation nicht möglich.',
    rateLimited: 'Zu viele Änderungen in kurzer Zeit. Bitte versuche es später erneut.',
    generic: 'Das hat nicht geklappt. Bitte versuche es erneut.',
    account_not_found: 'Diesen Account gibt es nicht.',
    relationship_not_found: 'Diese Verknüpfung gibt es nicht mehr. Lade die Seite neu.',
    invalid_token: 'Diese Einladung gibt es nicht.',
    self_relationship: 'Du kannst dich nicht selbst einladen.',
    team_role_required: 'Ein Team-Mitglied braucht eine Team-Rolle.',
    invalid_team_grant: 'Eine der Berechtigungen steht Team-Mitgliedern nicht zur Verfügung.',
    already_linked: 'Mit diesem Account bist du schon verknüpft, oder es ist bereits eine Einladung offen.',
    relationship_inactive:
      'Mit diesem Account gibt es eine deaktivierte Verknüpfung. Reaktiviere oder entferne sie in der Liste.',
    max_team_members_reached: 'Du hast die Höchstzahl an Team-Mitgliedern erreicht.',
    max_sub_customers_reached:
      'Du hast die Höchstzahl an Reseller-Kunden erreicht. Wende dich an den Support, wenn du mehr brauchst.',
    reseller_parent_exists: 'Dieser Account ist schon Kunde eines anderen Resellers.',
    circular_relationship: 'Dieser Account ist mit dir bereits in umgekehrter Richtung verknüpft.',
    invite_not_pending: 'Diese Einladung ist nicht mehr offen.',
    relationship_not_active: 'Diese Verknüpfung ist nicht aktiv.',
    relationship_already_active: 'Diese Verknüpfung ist bereits aktiv.',
    relationship_never_accepted: 'Diese Verknüpfung wurde nie angenommen und lässt sich nicht reaktivieren. Lade die Person neu ein.',
    invite_expired: 'Diese Einladung ist abgelaufen.',
    invite_email_mismatch: 'Die Einladung gilt für eine andere E-Mail-Adresse.',
    invalid_relationship: 'Diese Verknüpfung darfst du nicht ändern.',
    billing_mode_change_forbidden:
      'Diese Änderung des Abrechnungsmodus ist dir nicht erlaubt. Zurück auf gemeinsame Abrechnung stellen kann nur der Kunde selbst.',
    email_not_verified: 'Bestätige zuerst deine E-Mail-Adresse, dann kannst du das tun.',
    team_invite_from_staff: 'Staff-Accounts können keine Team-Mitglieder einladen.'
  },
  contextErrors: {
    login_mailbox_protected: 'Diese Adresse ist die Anmeldeadresse eines Accounts. Ihre Mails lassen sich nicht ändern, während du in einem anderen Account arbeitest.',
    team_context_forbidden:
      'Das bleibt dem Inhaber des Accounts vorbehalten und ist im Team-Zugriff nicht möglich.',
    acting_context_forbidden: 'Das geht nur in deinem eigenen Account. Kehre zuerst zu deinem Account zurück.',
    independent_billing_forbidden:
      'Dieser Kunde rechnet selbst ab und verwaltet Zahlungen, Bestellungen und Verträge selbst.'
  },
  notifications: {
    reactivationPending: 'Bestätigung angefragt',
    reactivationPendingMessage: 'Der Kunde bekommt eine Einladung und muss die Verknüpfung erneut bestätigen.',
    left: 'Verknüpfung verlassen',
    leftMessage: 'Du bist nicht mehr mit diesem Account verknüpft.',
    billingChanged: 'Abrechnungsmodus geändert',
    billingChangedMessage: 'Der neue Abrechnungsmodus gilt ab sofort.',
    inviteResent: 'Einladung erneut gesendet',
    inviteResentMessage: 'Die Einladung ist wieder 7 Tage gültig.',
    reactivated: 'Reaktiviert',
    reactivatedMessage: 'Die Sub-Account-Beziehung ist wieder aktiv.',
    removed: 'Entfernt',
    removedMessage: 'Die Sub-Account-Beziehung wurde entfernt.',
    inviteRevoked: 'Einladung zurückgezogen',
    inviteRevokedMessage: 'Die Einladung ist nicht mehr gültig.',
    inviteSent: 'Einladung gesendet',
    inviteSentMessage: 'Die Einladung wurde erfolgreich gesendet.',
    updated: 'Aktualisiert',
    updatedMessage: 'Die Sub-Account-Beziehung wurde aktualisiert.',
    deactivated: 'Deaktiviert',
    deactivatedMessage: 'Die Sub-Account-Beziehung wurde deaktiviert.'
  }
} as const
